var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShow = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22.61 13.9",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.3 13.9c3.93 0 7.67-2.19 10.84-6.34l.47-.56-.47-.6C19 2.19 15.23 0 11.3 0S3.63 2.19.46 6.35L0 7l.46.61c3.17 4.1 6.92 6.29 10.84 6.29m0-11.9c3.09 0 6.11 1.71 8.77 5-2.66 3.25-5.68 5-8.77 5s-6.11-1.8-8.77-5c2.66-3.29 5.68-5 8.77-5",
  className: "cls-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.26 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4m0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2",
  className: "cls-1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgShow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/show.e86cf1fbdf0feb8863763b1943c9138c.svg";